import { Component, Input, Output, EventEmitter, ViewChildren } from '@angular/core';
import { Validation } from '../../shared/services/validation.service';
import { ApplicationActions } from '../../actions/application.actions';
import { NgRedux } from '@angular-redux/store';
import * as _ from 'lodash';
import { InputPaths } from '../../shared/models/Enum/InputPaths';

@Component({
  selector: 'md-radio',
  template: require('./radio.component.html'),
  styles: [require('./radio.component.scss')]
})

export class RadioComponent {
  @Input() options;
  @Input() showUp;
  @Output() valueChange = new EventEmitter();
  @ViewChildren('radioInput') radioInputs;

  constructor(validation: Validation, appActions: ApplicationActions, ngRedux: NgRedux) {
    this.validation = validation;
    this.appActions = appActions;
    this.ngRedux = ngRedux;
    this.isValid = true;
    this.isResident = null;
    this.init = false;
    this.residenceInputPath = null;

    this.pathMap = {
      accountTypeRadio: 'ApplicationInformation.accountType',
      tradingLevels: 'InvestmentObjective.tradingLevels'
    };

    this.validateSub = this.validation.validateInput.subscribe(event => this.triggerValidation());
  }

  get radios() {
    if (this.options.radios === undefined) return [];
    if (typeof this.options.radios === 'object' && this.options.radios.length !== undefined) return this.options.radios;
    return _.sortBy(this.options.radios, radio => radio.order);
  }

  // @Todo: Rafactor and simplify this
  ngOnInit() {
    this.payload = {
      id: this.options.attr.id,
      show: {
        target: {
          id: this.options.attr.id,
          checked: false
        }
      },
      validationType: this.options.validationType,
      isValid: false,
      value: null
    };

    if (this.options.inputPath) {

      if (this.pathMap[this.options.inputPath]) {
        this.options.inputPath = this.pathMap[this.options.inputPath];
      }

      const arrayPath = this.options.inputPath.split('.');

      // residenceInputPath should only be set for the three paths below
      if (arrayPath[0] === InputPaths.CustodialMinorInformation
        || arrayPath[0] === InputPaths.JointAccountInformation
        || arrayPath[0] === InputPaths.PersonalInformation
      ) {
        this.residenceInputPath = `${arrayPath[0]}.permanentResident`;
        this.checkResidency();
      }

      arrayPath.unshift('applicationStore');
      this.arrayPath = arrayPath;

      if (this.options.inputPath.match(/\[\d+\]/) !== -1) {
        this.reduxObservable$ =
          this.ngRedux.select(state => _.get(state, `applicationStore.${this.options.inputPath}`));
      } else {
        this.reduxObservable$ = this.ngRedux.select(this.arrayPath);
      }

      this.reduxSubscription = this.reduxObservable$.subscribe(state => {
        this.currentValue = state;

        if (this.currentValue == null && this.init === false) {
          // Check for default value
          const defaultValue = this.radios.filter(radio => (radio.attr || {}).checked === true);
          if (defaultValue.length > 0) {
            this.currentValue = this.mapToBoolean(defaultValue[0].attr.id);
            if (this.currentValue === null) this.currentValue = defaultValue[0].attr.id;
          }
        }

        if (this.currentValue !== true && this.currentValue !== false) {
          if (this.radios.length === 6 && this.options.inputType === 'radio') { // select-account-type specific
            this.radios.forEach(radio => {
              if (this.radios[radio]) this.radios[radio].attr.checked = false;
            });
          }
          const radio = this.radios.filter(radio => radio.attr.id === this.currentValue)[0];
          if (radio != null) {
            radio.attr.checked = true;
            const payload = {
              id: this.options.attr.id,
              isValid: true
            };
            this.validation.validCheck(payload);
          }
        } else {
          for (const radio of this.radios) {
            const radioValue = this.mapToBoolean(radio.attr.id);
            if (radioValue === this.currentValue) {
              radio.attr.checked = true;
            } else {
              radio.attr.checked = false;
            }
          }
        }

        if (this.currentValue != null) {
          this.payload.value = this.currentValue;
          this.payload.show.target.checked = true;
        } else {
          // Pull payload value from form definition
          for (const radio of this.radios) {
            if (radio.attr.checked === true) {
              let value = this.mapToBoolean(radio.attr.id);
              if (value === null) value = radio.attr.id;

              this.payload.value = value;
              this.payload.show.target.checked = true;
            }
          }
        }

        if (this.options.validationType != null) {
          const isValidObj = { state: true };
          this.payload.isValid = isValidObj.state;
        } else {
          this.payload.isValid = true;
        }

        if (this.init === false) {
          this.appActions.setData(this.options.inputPath, this.payload.value);
        }

        this.validation.validCheck(this.payload);

        this.init = true;
        this.valueChange.emit(this.payload);
      });
    }
  }

  triggerValidation() {
    const isValidObj = this.validation.validate(this.options.validationType, this.payload.value);
    if (isValidObj != null) {
      this.isValid = isValidObj.state;
      if (!this.isValid) {
        this.options.msg = this.options.msg || {};
        if (isValidObj.msg) this.options.msg.fail = isValidObj.msg;
      } else {
        this.options.msg = undefined;
      }
      let isValid = this.isValid;
      if (this.showUp === false) {
        isValid = true;
      }
      this.validation.validCheck({
        id: this.options.attr.id,
        isValid
      });
      if (this.radioInputs.first && !isValid) { // accessibility
        this.radioInputs.first.nativeElement.focus();
      }
    }
  }

  ngOnDestroy() {
    if (this.validateSub) {
      this.validateSub.unsubscribe();
    }

    if (this.options.inputPath) {
      this.reduxObservable$.unsubscribe();
      this.reduxSubscription.unsubscribe();
    }
  }

  mapToBoolean(value) {
    // the "no" part of nonResident value would cause false positive in the regex below:
    if (this.options.attr.id === 'residency') { return null; }
    const matches = value.match(/^(yes|no)?.*?(?:(yes|no))?$/i);
    if (matches[1] !== undefined || matches[2] !== undefined) {
      return (matches[1] || '').toLowerCase() === 'yes' || (matches[2] || '').toLowerCase() === 'yes';
    }
    return null;
  }

  // Special case I need to figure out how to move out of here (if possible)
  // really want to find a way to abstract this out
  checkSpecialDisplay(input) {
    // Option Levels
    const optMatch = input.attr.id.match(/^optionLevel(\d)$/);
    if (optMatch) {
      const optionLevel = this.appActions.getData('appState.investmentLevel', 0);

      return optionLevel >= optMatch[1];
    }

    return true;
  }

  optionsVisible() {
    if (this.payload.id !== 'tradingLevels') {
      return true;
    }

    return this.appActions.getData('appState.investmentLevel', 0) > 0;
  }

  checkResidency() {
    const residencyChoice = this.appActions.getData(this.residenceInputPath);
    if (residencyChoice !== null && this.options.inputPath === this.residenceInputPath) {
      this.residencyChoice = residencyChoice ? 'resident' : 'nonResident';
    }
  }

  onChange(event) {
    const radioID = event.target.id || event.srcElement.id;

    let value = this.options.attr.id === 'residency' ? JSON.parse(event.target.value) : this.mapToBoolean(radioID);
    if (value == null) value = radioID;

    this.payload = {
      id: this.options.attr.id,
      validationType: this.options.validationType,
      value,
      show: event
    };

    this.triggerValidation();

    if (this.options.inputPath) {
      this.appActions.setData(this.options.inputPath, value);
      if (this.residenceInputPath) { this.checkResidency(); }
    } else {
      this.valueChange.emit(this.payload);
    }
  }
}
